import styled from 'styled-components';

export const Wrapper = styled.div`
	margin-top: 2rem;
`;

export const OptionalServicesWrapper = styled.div`
	margin-top: 2rem;
`;
